import React from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import List from './List'
import Show from './Show'

const Clients: React.FC = ({}) => {
  const { path } = useRouteMatch()

  return (
    <>
      <Switch>
        <Route path={path + '/:id'}>
          <Show />
        </Route>
        <Route path={path + '/'}>
          <List />
        </Route>
        <Redirect from={path} to={path + '/'} />
      </Switch>
    </>
  )
}

export default Clients
